export default {
  LOGIN: '/login',
  CLIENTS: '/clients',
  ACCESS_PROFILE: '/access-profile',
  ACCESS_PROFILE_FORM: '/access-profile-form',
  ACCESS_PROFILE_CONFIG: '/access-profile-config',
  PRODUCTS: '/products',
  CATEGORY: '/category',
  PROMOTION: '/promotion',
  RECOMMENDED: '/recommended',
  REGISTER_SOLICITATION: '/register-solicitation',
  REGISTER_MONITOR: '/register-monitor',
  REGISTER_MONITOR_DETAILS: '/register-monitor-details',
  REGISTER_MONITOR_EDIT: '/register-monitor-edit',
  HOME: '/',
  FORM: '/form',
  USERS: '/users',
  ALL_USERS: '/all-users',
  ORDERS: '/orders',
  ORDERS_CHECKBUY: '/orders-checkbuy',
  ORDERS_PUNCHOUT: '/orders-punchout',
  UPLOAD_PRODUCTS: '/upload-products',
  UPLOAD_USERS: '/upload-users',
  UPLOAD_CLIENTS: '/upload-clients',
  UPLOAD_CLIENT_USERS: '/upload-client-users',
  UPLOAD_CATEGORIES: '/upload-categories',
  UPLOAD_BANNERS: '/upload-banners',
  UPLOAD_MANUFACTURERS: '/upload-manufacturers',
  UPLOAD_FEATURED_MANUFACTURE: '/upload-featured-manufacture',
  UPLOAD_PROMOTIONS: '/upload-promotions',
  UPLOAD_RECOMMENDEDS: '/upload-recommendeds',
  UPLOAD_ADMINISTRATORS: '/upload-administrators',
  BANNERS: '/banners',
  MANUFACTURERS: '/manufacturers',
  BANNERS_FORM: '/banners-form',
  MANUFACTURERS_FORM: '/manufacturers-form',
  LAYOUT: '/layout',
  FEATURED_MANUFACTURE: '/featured-manufacture',
  FEATURED_MANUFACTURE_FORM: '/featured-manufacture-form',
  PARAMETERS: '/parameters',
  PARAMETERS_PLACES_FORM: '/parameters-places-form',
  PARAMETERS_LEAD_TIME_FORM: '/parameters-lead-time-form',
  PARAMETERS_FAMILIES_FORM: '/parameters-families-form',
  ADMIN_USERS: '/admin-users',
  PUNCHOUT_RULE: '/punchout-rule',
  PUNCHOUT_N2_RULE: '/punchout-n2-rule',
  ADM_MENU_1: '/admin-menu-1?level=1',
  ADM_MENU_2: '/admin-menu-2?level=2',
  ADM_MENU_3: '/admin-menu-3?level=3',
  ADM_MENU_4: '/admin-menu-4?level=4',
  ADM_MENU_5: '/admin-menu-5?level=5',
  ADM_MENU_FORM: '/admin-menu-form',
  ACCESS_LOGIN_REPORT: '/access-login-report',
  DISCOUNT_COUPON: '/discount-coupon',
  DISCOUNT_COUPON_HISTORY: '/discount-coupon-history',
  UPLOAD_DISCOUNT_COUPON: '/upload-discount-coupon',
  PRODUCT_FEEDBACK_REASON: '/product-feedback-reason',
  PURCHASE_FEEDBACK: '/purchase-feedback',
  PROJECTS_DIRECTORY: '/projects-directory',
  UPLOAD_PROJECTS_DIRECTORY: '/upload-projects-directory',
  TECHNICAL_MATERIAL: '/technical-material',
  UPLOAD_TECHNICAL_MATERIAL: '/upload-technical-material',
  COURSES_AND_TRAINING: '/courses-and-training',
  NOTIFICATION_EMAIL: '/notification-email',
  UPLOAD_COURSES_AND_TRAINING: '/upload-courses-and-training',
  CONTACTO_OF_PROJECTS_FOR_INTEGRATORS: '/contacto-of-projects-for-integrators',
  NOTIFY: '/notify',
  NOTIFY_HISTORY: '/notify-history',
  TYPE_SOLUTION: '/type-solution',
  CABLE_CATEGORY: '/cable-category',
  TYPE_COATING: '/type-coating',
  PRODUCT_TELECOM: '/product-telecom',
  SUPPLIER_TELECOM: '/supplier-telecom',
  PURCHASE_REPORT: '/purchase-report',
  SUPPLIER_AUTOMATION: '/supplier-automation',
  APPLICATION_TYPE: '/application-type',
  VOLTAGE: '/voltage',
  POWER_RANGE: '/power-range',
  POWER: '/power',
  AUTOMATION_PRODUCTS: '/automation_products',
  UPLOAD_AUTOMATION_PRODUCTS: '/upload-automation_products',
  ABANDONED: '/abandoned',
  OVERDUE_CLIENTS: '/overdue-clients',
  BRANCH_MANAGER: '/branch-manager',
  PACKS: '/packs',
  UPLOAD_PACKS: '/upload-packs',
  ANALYTICS: '/analytics',
};
